/* STATE */
import { call, put, takeLatest } from 'redux-saga/effects';

import { api } from './api';
import { environment } from 'environments/environment';
import { ExtendedAxiosResponse } from 'helpers/apiClient';
import {
  AppAction,
  createActionType,
  createApiActionCreators,
  RequestActionTypes,
} from 'helpers/redux/reduxHelpers';
import { ApiClientRequest } from 'models/ApiClientRequest';
import { getApiUrl, performApiCall } from 'saga/apiClient/ducks';

export interface ClaimStep5Payload {
  invoiceNumber?: string;
  claimId?: number;
  serviceId?: number;
  accountNo?: string;
  histInvNo?: Array<string>;
}

/* ACTION TYPES */
export enum ClaimStep5StateTypes {
  GetData = '@@ClaimStep5/GET_DATA',
  SaveClaimStep5 = '@@ClaimStep5/SAVE_CLAIM_STEP_5',
}

/* ACTIONS */
export const getClaimStep5DataActions = createApiActionCreators(ClaimStep5StateTypes.GetData);
export const saveClaimStep5Actions = createApiActionCreators(ClaimStep5StateTypes.SaveClaimStep5);

/* SAGAS */

function* getData({ payload }: AppAction<ClaimStep5Payload>) {
  if (!payload.invoiceNumber || !payload.claimId || !payload.serviceId) return;

  const request: ApiClientRequest = {
    apiCall: call(
      api.getData,
      yield getApiUrl(environment.urlConfig.billingManagement),
      payload.invoiceNumber,
      payload.claimId,
      payload.serviceId
    ),
  };
  const resp: ExtendedAxiosResponse = yield call(performApiCall, request);

  if (resp.ok) {
    yield put(getClaimStep5DataActions.success(resp.data));
  } else {
    yield put(getClaimStep5DataActions.failure());
  }
}

function* saveClaimStep5({ payload }: AppAction<ClaimStep5Payload>) {
  if (!payload.invoiceNumber || !payload.claimId) return;

  const request: ApiClientRequest = {
    apiCall: call(
      api.saveClaimStep5,
      yield getApiUrl(environment.urlConfig.billingManagement),
      payload.invoiceNumber,
      payload.claimId,
      payload.serviceId,
      payload.histInvNo
    ),
  };
  const resp: ExtendedAxiosResponse = yield call(performApiCall, request);

  if (resp.ok) {
    yield put(saveClaimStep5Actions.success());
  } else {
    yield put(saveClaimStep5Actions.failure());
  }
}

/* EXPORT */
export function* claimStep5Saga() {
  yield takeLatest(createActionType(ClaimStep5StateTypes.GetData, RequestActionTypes.REQUEST), getData);
  yield takeLatest(createActionType(ClaimStep5StateTypes.SaveClaimStep5, RequestActionTypes.REQUEST), saveClaimStep5);
}
